
<div class="python-artwork artwork" #pyArtwork *ngIf="selectedArtwork?.id === 1"
(mouseenter)="animatePyForward()" (mouseleave)="animatePyBackward()">
  <div class="py-front-container">
    <img src="assets/images/artworks/python-front.svg" alt="" class="py-front">
  </div>
  <div class="py-back-container">
    <img src="assets/images/artworks/python-back.svg" alt="" class="py-back">
  </div>
  <img src="assets/images/artworks/python-lines.svg" alt="" class="py-lines">
</div>
<div class="mod-2-artwork artwork" #mod2 *ngIf="selectedArtwork?.id === 2"
(mouseenter)="animateMod2Forward()" (mouseleave)="animateMod2Backward()">
  <img src="assets/images/artworks/mod-2-artwork.png" alt="" class="mod-img">
</div>
<div class="mod-3-artwork artwork" #mod3 *ngIf="selectedArtwork?.id === 3"
(mouseenter)="animateMod3Forward()" (mouseleave)="animateMod3Backward()">
  <img src="assets/images/artworks/mod-3-artwork.png" alt="" class="mod-img">
</div>
<div class="mod-4-artwork artwork" #mod4 *ngIf="selectedArtwork?.id === 4"
(mouseenter)="animateMod4Forward()" (mouseleave)="animateMod4Backward()">
  <img src="assets/images/artworks/mod-4-5-artwork.png" alt="" class="mod-img">
</div>
<div class="mod-5-artwork artwork" #mod5 *ngIf="selectedArtwork?.id === 5"
(mouseenter)="animateMod5Forward()" (mouseleave)="animateMod5Backward()">
  <img src="assets/images/artworks/mod-4-5-artwork.png" alt="" class="mod-img">
</div>
<div class="mod-6-artwork artwork" #mod6 *ngIf="selectedArtwork?.id === 6"
(mouseenter)="animateMod6Forward()" (mouseleave)="animateMod6Backward()">
  <img src="assets/images/artworks/mod-6-artwork.png" alt="" class="mod-img">
  <div class="light"></div>
</div>
<div class="mod-7-artwork artwork" #mod7 *ngIf="selectedArtwork?.id === 7"
(mouseenter)="animateMod7Forward()" (mouseleave)="animateMod7Backward()">
  <img src="assets/images/artworks/mod-7-artwork.png" alt="" class="mod-img">
</div>
<div class="mod-8-artwork artwork" #mod8 *ngIf="selectedArtwork?.id === 8"
(mouseenter)="animateMod8Forward()" (mouseleave)="animateMod8Backward()">
  <img src="assets/images/artworks/mod-8-artwork-bg.png" alt="" class="mod-bg">
  <img src="assets/images/artworks/mod-8-r-artwork.png" alt="" class="mod-img mod-img-r">
  <img src="assets/images/artworks/mod-8-l-artwork.png" alt="" class="mod-img mod-img-l">
</div>
<div class="mod-9-artwork artwork" #mod9 *ngIf="selectedArtwork?.id === 9"
(mouseenter)="animateMod9Forward()" (mouseleave)="animateMod9Backward()">
  <img src="assets/images/artworks/mod-9-cap-artwork.png" alt="" class="mod-img mod-img-cap">
  <img src="assets/images/artworks/mod-9-arc-artwork.png" alt="" class="mod-img mod-img-arc">
</div>
<div class="mod-10-artwork artwork" #mod10 *ngIf="selectedArtwork?.id === 10"
(mouseenter)="animateMod10Forward()" (mouseleave)="animateMod10Backward()">
  <img src="assets/images/artworks/mod-10-globe-artwork.png" alt="" class="mod-img mod-img-globe">
  <img src="assets/images/artworks/mod-10-upwork-artwork.png" alt="" class="mod-img mod-img-upwork">
  <img src="assets/images/artworks/mod-10-linkedin-artwork.png" alt="" class="mod-img mod-img-linkedin">
</div>
